export default __webpack_public_path__ + "static/media/girl-eating@2x.154758c4.png";